import {Button, Result} from "antd-mobile";

export default function ERR404() {
    return <Result
        title="地址错误 , 页面不存在 !"
        status='error'
    />
}